import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};
// POST
export const createBounty = async (bounty) => {
    try {
        const url = `${BASE_URL}/bounty?version=2`;

        const accessToken = await getAccessToken();

        const response = await axios.post(url, bounty, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        // toast.error('Sorry unable to create your organization.');
    }
};

export const updateBounty = async (bounty, bountyId) => {
    try {
        const url = `${BASE_URL}/bounty/${bountyId}?version=2`;

        const accessToken = await getAccessToken();

        const response = await axios.put(url, bounty, getConfig(accessToken));

        if (response) if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        return error;
        // toast.error('Sorry unable to create your organization.');
    }
};
// GET /organisation/bounty?organisationId=<id>&page=<page number>&entriesPerPage=<per page entry count></per>
export const getBounties = async (id, page, entriesPerPage, queryParams = {}) => {
    try {
        let url = `${BASE_URL}/organisation/bounty?organisationId=${id}&fetchEntryCount=false&page=${page}&entriesPerPage=${entriesPerPage}`;
        if (queryParams.includeProjectBounties) url += `&includeProjectBounties=true`;
        if (queryParams.includeIndividualBounties) url += `&includeIndividualBounties=true`;
        if (queryParams.includeEventBounties) url += `&includeEventBounties=true`;

        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getBountiesCount = async (id, queryParams = {}) => {
    try {
        let url = `${BASE_URL}/organisation/bounty?organisationId=${id}&fetchEntryCount=true`;
        if (queryParams.includeProjectBounties) url += `&includeProjectBounties=true`;
        if (queryParams.includeIndividualBounties) url += `&includeIndividualBounties=true`;
        if (queryParams.includeEventBounties) url += `&includeEventBounties=true`;

        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getUnvalidatedBounties = async (id, page, pageEntries, queryParams = {}) => {
    try {
        let url = `${BASE_URL}/organisation/validation/bounty?organisationId=${id}&fetchEntryCount=false&page=${page}&entriesPerPage=${pageEntries}`;
        if (queryParams.includeProjectBounties) url += `&includeProjectBounties=true`;
        if (queryParams.includeIndividualBounties) url += `&includeIndividualBounties=true`;
        if (queryParams.includeEventBounties) url += `&includeEventBounties=true`;

        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getUnvalidatedBountiesCount = async (id, queryParams = {}) => {
    try {
        let url = `${BASE_URL}/organisation/validation/bounty?organisationId=${id}&fetchEntryCount=true`;
        if (queryParams.includeProjectBounties) url += `&includeProjectBounties=true`;
        if (queryParams.includeIndividualBounties) url += `&includeIndividualBounties=true`;
        if (queryParams.includeEventBounties) url += `&includeEventBounties=true`;

        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

// GET /organisation/validation/bounty/<bountyId>?page=<page number>&entriesPerPage=<per page entry count></per>

export const getBounty = async (id) => {
    try {
        const url = `${BASE_URL}/bounty/details/${id}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const deleteBounty = async (id) => {
    try {
        const url = `${BASE_URL}/bounty/${id}`;

        const accessToken = await getAccessToken();
        const response = await axios.delete(url, getConfig(accessToken));

        // if (response.status === 201) toast.success('Project is successfully created !');
        return response.data;
    } catch (error) {
        toast.error(error.response.data.message);

        // toast.error('Sorry unable to create your organization.');
    }
};

export const withdrawBounty = async (id) => {
    try {
        const url = `${BASE_URL}/bounty/withdrawFundingRequest?bountyId=${id}`;

        const accessToken = await getAccessToken();
        const response = await axios.patch(url, {}, getConfig(accessToken));

        console.log(response, 'afer withdrawn');

        // if (response.status === 201) toast.success('Project is successfully created !');
        return response.data;
    } catch (error) {
        toast.error(error.response.data.message);
        // toast.error('Sorry unable to create your organization.');
    }
};

export const getBountySubmissions = async (bountyId, page = 1, entriesPerPage = 1000) => {
    try {
        const url = `${BASE_URL}/organisation/validation/bounty/${bountyId}?fetchEntryCount=false&page=${page}&entriesPerPage=${entriesPerPage}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getBountySubmissionsCount = async (bountyId) => {
    try {
        const url = `${BASE_URL}/organisation/validation/bounty/${bountyId}?fetchEntryCount=true`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

// /organisation/validation/preview/<bountyId></bountyId>
export const getValidationPreview = async (bountyId) => {
    try {
        const url = `${BASE_URL}/organisation/validation/preview/${bountyId}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
export const getBountySubmission = async (submissionId) => {
    try {
        const url = `${BASE_URL}/organisation/validation/submission/${submissionId}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
// PATCH /organisation/validation/submission/<submissionId></submissionId>

export const remarkSubmission = async (submissionId, payload) => {
    try {
        const url = `${BASE_URL}/organisation/validation/submission/${submissionId}`;

        const accessToken = await getAccessToken();
        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) toast.success('Submission Validated');
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.message);
        // toast.error('Sorry unable to create your organization.');
    }
};
// PATCH:${BASE_URL}/bounty/start<bountyId>
export const startBounty = async (payload, bountyId, transactionHash) => {
    try {
        // PATCH /bounty/start?transactionHash=<hash></hash>
        const url = `${BASE_URL}/bounty/start/${bountyId}${transactionHash ? `?transactionHash=${transactionHash}` : ''}
          `;

        const accessToken = await getAccessToken();

        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        // toast.error('Sorry unable to create your organization.');
    }
};

// /bounty/requestDeployment?bountyId=68c285d89a0459bc0adc16bf

export const requestDeployment = async (payload, bountyId, transactionHash) => {
    try {
        // PATCH /bounty/start?transactionHash=<hash></hash>
        const url = `${BASE_URL}/bounty/requestDeployment?bountyId=${bountyId}`;

        const accessToken = await getAccessToken();

        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        // toast.error('Sorry unable to create your organization.');
    }
};

export const requestFunding = async (payload, bountyId, fundingRequiredBy) => {
    try {
        const url = `${BASE_URL}/bounty/requestFunding?bountyId=${bountyId}&fundingRequiredBy=${fundingRequiredBy}`;

        const accessToken = await getAccessToken();

        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        return { success: false, status: error?.response?.data?.code };
        // toast.error('Sorry unable to create your organization.');
    }
};

export const sendRequestForVoting = async (payload) => {
    try {
        const url = `${BASE_URL}/orgRequest`;

        const accessToken = await getAccessToken();

        const response = await axios.post(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        toast.error(error);
        // toast.error('Sorry unable to create your organization.');
    }
};

export const publishOrUnpublishBounty = async (id) => {
    try {
        const url = `${BASE_URL}/bounty/togglePublish/${id}`;

        const accessToken = await getAccessToken();
        const response = await axios.patch(url, {}, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) toast.success(' Bounty status changed !');
        return response;
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message);
        // toast.error('Sorry unable to create your organization.');
    }
};

// PATCH /bounty/updateExpiration
export const updateBountyExpiration = async (bountyId, operation) => {
    const payload = {
        bountyId: bountyId,
        operation: operation,
    }
    try {
        const url = `${BASE_URL}/bounty/updateExpiration`;
        const accessToken = await getAccessToken();
        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) {

            return response.data;
        }
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message);
    }
};


export const extendBountyExpiration = async (bountyId, operation, newExpirationDate, newValidationDate) => {
    const payload = {
        bountyId: bountyId,
        operation: operation,
        expirationTimestamp: newExpirationDate,
        ...(newValidationDate && { validationTillDate: newValidationDate })
    }
    try {
        const url = `${BASE_URL}/bounty/updateExpiration`;
        const accessToken = await getAccessToken();
        const response = await axios.patch(url, payload, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) {

            return response.data;
        }
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message);
    }
};

export const getRewardAmount = async (bountyId, tokenInfoId) => {
    try {
        const url = `${BASE_URL}/bounty/rewardAmount?bountyId=${bountyId}&tokenInfoId=${tokenInfoId}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const updateRewardToken = async (bountyId, tokenInfoId) => {
    try {
        const url = `${BASE_URL}/bounty/rewardToken?bountyId=${bountyId}&tokenInfoId=${tokenInfoId}`;
        const accessToken = await getAccessToken();
        const response = await axios.patch(url, {}, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            toast.success('Reward token updated successfully');
            return response.data;
        }
    } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message || 'Failed to update reward token');
        return error;
    }
};